import React from 'react';
import { Film, Tv, Smartphone, Briefcase } from 'lucide-react';
import { mockData } from '../mock';

const Categories = () => {
  const iconMap = {
    'Short Films': Film,
    'Commercial Films': Tv,
    'Digital Campaigns': Smartphone,
    'Branded Content': Briefcase
  };

  return (
    <section className="bg-black py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-400 to-amber-600">
              Expertise
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Diverse portfolio across multiple storytelling mediums
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {mockData.categories.map((category) => {
            const Icon = iconMap[category.name];
            return (
              <div
                key={category.name}
                className="group relative bg-gradient-to-br from-gray-900 to-black p-8 rounded-lg border border-gray-800 hover:border-amber-400/50 transition-all duration-500 overflow-hidden cursor-pointer"
              >
                {/* Background Effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-amber-400/0 to-amber-400/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                {/* Content */}
                <div className="relative space-y-6">
                  {/* Icon */}
                  <div className="w-14 h-14 rounded-full bg-amber-400/10 flex items-center justify-center group-hover:bg-amber-400/20 group-hover:scale-110 transition-all duration-300">
                    <Icon className="text-amber-400" size={24} />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-white group-hover:text-amber-400 transition-colors">
                    {category.name}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {category.description}
                  </p>

                  {/* Count */}
                  <div className="text-3xl font-bold text-amber-400/50 group-hover:text-amber-400 transition-colors">
                    {category.count}+
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Categories;